import styled, {css} from 'styled-components';

const baseBtn = css`
  width: 60px;
  height: 60px;
  border-radius: 10px;
  border: 3px solid #ff4f12;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  transition: 0.2s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 24px;
`;

export const PaginationButton = styled.button`
  ${baseBtn};
  color: #ff5a0a;
`;

export const PaginationPageButton = styled.button<{$active?: boolean}>`
  width: 60px;
  height: 60px;
  border-radius: 10px;
  border: none;
  background: ${({$active}) => ($active ? '#FF4F12' : '#f3f3f3')};
  color: ${({$active}) => ($active ? '#fff' : '#FF4F12')};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
  cursor: pointer;
  transition: 0.2s ease;
`;

export const PaginationDots = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 10px;
  background: #f3f3f3;
  color: #ff4f12;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 800;
`;
